import { render } from "./LargeVideoframe.vue?vue&type=template&id=39cab34e"
import script from "./LargeVideoframe.vue?vue&type=script&lang=js"
export * from "./LargeVideoframe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__